/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationBrandCatalogs200ResponseCatalogsInner
 */
export interface GetLocationBrandCatalogs200ResponseCatalogsInner {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseCatalogsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseCatalogsInner
     */
    name: string;
}

/**
 * Check if a given object implements the GetLocationBrandCatalogs200ResponseCatalogsInner interface.
 */
export function instanceOfGetLocationBrandCatalogs200ResponseCatalogsInner(value: object): value is GetLocationBrandCatalogs200ResponseCatalogsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSON(json: any): GetLocationBrandCatalogs200ResponseCatalogsInner {
    return GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseCatalogsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationBrandCatalogs200ResponseCatalogsInner {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetLocationBrandCatalogs200ResponseCatalogsInnerToJSON(json: any): GetLocationBrandCatalogs200ResponseCatalogsInner {
    return GetLocationBrandCatalogs200ResponseCatalogsInnerToJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseCatalogsInnerToJSONTyped(value?: GetLocationBrandCatalogs200ResponseCatalogsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'id': value['id'],
        'name': value['name'],
    };
}

